'use client';

import { MouseEvent as ReactMouseEvent } from 'react';
import { Button } from 'ui';
import ContactMail from 'icons/lib/kontakt_mail_48.svg';
import ContactForm from 'icons/lib/contact_form.svg';
import ContactTel from 'icons/lib/kontakt_tel_48.svg';
import { useTranslation } from '@/i18n/client';
import { useCurrentLocale } from '@/shared/utils/client';
import { useRouter } from 'next/navigation';
import { routes } from '@/shared/data/routes';

import styles from './ContactCards.module.scss';
import Link from 'next/link';

import { ContactCardProps } from './types';
import { LOCALE } from 'utils';

export function ContactCards({ contactFormRef, showTitle = true }: ContactCardProps) {
	const { t } = useTranslation('common');
	const router = useRouter();
	const locale = useCurrentLocale();

	const handleGoToFormPress = (e: ReactMouseEvent<Element, MouseEvent>) => {
		e.preventDefault();

		if (!contactFormRef?.current) {
			router.push(`${routes[locale].CONTACT}?field=name`);

			return;
		}

		contactFormRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });

		const nameInput = document.getElementsByClassName('nameInput')[0] as HTMLInputElement;

		nameInput.focus({ preventScroll: true });
	};

	return (
		<div>
			{showTitle && (
				<div className={styles.contact__cardsIntro}>
					<h3>{t('common.contactUs2')}</h3>
					<p>{t('common.callUsAvailability2')}</p>
				</div>
			)}
			<div className={styles.contact__cardsContainer}>
				<div className={styles.infoCard__container}>
					<div className={styles.infoCard__head}>
						<div className={`${styles.infoCard__icon} ${styles.__blue}`}>
							<ContactForm />
						</div>
						<h3>{t('common.formContact')}</h3>
						<div className={styles.infoCard__content}>{t('common.formContactInformation')}</div>
					</div>
					<Button
						variant="secondary"
						href="#"
						buttonName="blueButton"
						as={Link}
						onPress={handleGoToFormPress}
					>
						{t('common.goToForm')}
					</Button>
				</div>

				<div className={styles.infoCard__container}>
					<div className={styles.infoCard__head}>
						<div className={styles.infoCard__icon}>
							<ContactMail />
						</div>
						<h3>{t('common.writeToUs')}</h3>
						<div className={styles.infoCard__content}>{t('common.oneDayMassageAnswer')}</div>
					</div>
					<h3 className={styles.infoCard__email}>
						<a href={`mailto:${t('common.org.email')}`}>{t('common.org.email')}</a>
					</h3>
				</div>

				{locale === LOCALE.PL ? (
					<div className={styles.infoCard__container}>
						<div className={styles.infoCard__head}>
							<div className={`${styles.infoCard__icon} ${styles.__green}`}>
								<ContactTel />
							</div>
							<h3>{t('common.callUs')}</h3>
							<div className={styles.infoCard__content}>{t('common.callUsAvailability')}</div>
							<h3>
								<a href={`tel:${t('common.phoneLabel')}`} className={styles.__green}>
									{t('common.phoneLabel')}
								</a>
							</h3>
							<div className={styles.infoCard__content}>{t('common.trafficInformation')}</div>
						</div>
					</div>
				) : null}
			</div>
		</div>
	);
}
